import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@app/classes';
import { AuthService } from '@app/services';
import { HiringAccessLevelIdsEnum, HiringAccessLevelsEnum } from '@applicant-tracker/enums/hiring-access-levels.enum';
import { Employee } from '@models/employee/employee.model';
import { ManagerAssignment } from '@models/recruiting/manager-assignment.model';
import _groupBy from 'lodash-es/groupBy';

@Component({
    selector: 'app-hiring-team-list',
    templateUrl: './hiring-team-list.template.html',
    styleUrls: ['./hiring-team-list.style.scss'],
})
export class HiringTeamListComponent implements OnInit {
    @Input() showEditButton = true;
    @Input() showTitle = true;
    @Input() noEmployeeMessage = 'applicant-tracker.noEmployeeHiringTeam';
    @Input() assignments: ManagerAssignment[] = [];

    hiringTeam: { accessLevel: string; employees: Employee[] }[] = [];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private auth: AuthService
    ) {
        this.showEditButton = this.auth.can(Platform.recruiting.permission.recruiter);
    }

    ngOnInit(): void {
        this.setHiringTeam();
    }

    onEdit(): void {
        this.router.navigate(['manage-hiring-team'], { relativeTo: this.route });
    }

    private getAccessLevel(accessLevelId: number | null): string {
        for (const key in HiringAccessLevelIdsEnum) {
            if (HiringAccessLevelIdsEnum[`${key}`] === accessLevelId) {
                return HiringAccessLevelsEnum[key];
            }
        }

        return null;
    }

    private setHiringTeam(): void {
        const groupedAssignments: { [accessLevelId: string]: ManagerAssignment[] } = _groupBy(
            this.assignments,
            'accessLevelId'
        );

        this.hiringTeam = Object.entries(groupedAssignments)
            .map(([strAccessLevelId, assignments]) => {
                const employees: Employee[] = assignments.map((assignment: ManagerAssignment) => {
                    return assignment.employee;
                });

                const accessLevelId = strAccessLevelId === 'null' ? null : parseInt(strAccessLevelId, 10);

                const accessLevel = this.getAccessLevel(accessLevelId);

                return { accessLevelId, accessLevel, employees };
            })
            .sort((a, b) => (a.accessLevelId < b.accessLevelId ? -1 : 1));
    }
}
